module.exports = __webpack_public_path__ + "./fonts/fa6ProRegular.ttf";